import some from 'lodash-es/some';

import { TOGGLE_PAIRS } from 'constants/filters/filter-config';
import * as Constants from 'constants/index';

// Map of filter id -> whether it is currently selected/active.
type SelectedFiltersState = Record<string, boolean>;

interface FilterAction {
  type: string;
  id: string;
}

const initialState: SelectedFiltersState = {};

const toggleFilter = (state: SelectedFiltersState, action: FilterAction): SelectedFiltersState => {
  const newState: SelectedFiltersState = {
    ...state,
    [action.id]: !state[action.id],
  };
  const toggleSet = TOGGLE_PAIRS.find((tSet) => some(tSet, { id: action.id }));
  if (toggleSet) {
    const pairedToggle = toggleSet.find((toggle) => toggle.id !== action.id);
    // `pairedToggle` is guaranteed present (each TOGGLE_PAIRS entry has two
    // distinct ids); the `!` preserves the original JS which read `.id`
    // directly (throwing if it were ever undefined).
    return {
      ...newState,
      [pairedToggle!.id]: state[action.id],
    };
  }
  return newState;
};

export const SelectedFiltersReducer = (
  state: SelectedFiltersState = initialState,
  action: FilterAction,
): SelectedFiltersState => {
  switch (action.type) {
    case Constants.SuperAdmin.FILTER_ACTION_TYPES.TOGGLE_FILTER:
      return toggleFilter(state, action);
    case Constants.SuperAdmin.FILTER_ACTION_TYPES.CLEAR_FILTERS:
      return initialState;
    case Constants.SuperAdmin.SELECTOR_ACTION_TYPES.SELECT_TOOL:
      return initialState;
    default:
      return state;
  }
};
